import { FC } from "react"

import { Flex, FlexItem } from "components/Flex"
import Pictogram, { IPictogramProps } from "components/Pictogram/Pictogram"

interface ILmidModalResultItemProps {
    pictogram: IPictogramProps
    align: React.CSSProperties["alignItems"]
    condensed?: boolean
    onClick?(): void
}

const LmidModalResultItem: FC<React.PropsWithChildren<ILmidModalResultItemProps>> = ({
    pictogram,
    align,
    condensed,
    onClick,
    children
}) => {
    function renderContent() {
        return (
            <Flex alignItems={align}>
                <FlexItem>
                    <Pictogram
                        {...pictogram}
                    />
                </FlexItem>
                <FlexItem className="pl-3 w-100 text-left">
                    {children}
                </FlexItem>
            </Flex>
        )
    }

    if (onClick) {
        return (
            <button className={`w-auto d-inline-block ${condensed ? 'px-2 py-1' : 'p-3'} bg-h-grey-100 transition cursor-pointer round-sm`}
                onClick={onClick}>
                {renderContent()}
            </button>
        )
    }

    return (
        <div className={`w-auto d-inline-block ${condensed ? 'px-2 py-1' : 'p-3'}`}>
            {renderContent()}
        </div>
    )
}

export default LmidModalResultItem
